/**
 * External Imports
 */
import { FC, Dispatch, SetStateAction } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../redux/store';

/**
 * Internal Imports
 */
import AdhocEmployeesTable from '../../components/customTables/employees/adhocEmployeesTable';
import SearchHeader from '../../components/searchHeader';
import Loading from '../../components/shared/Loading';

/**
 * Global Type Definition Imports
 */
import { Employee } from '../../config/interfaces';

/**
 * Style Imports
 */
import { EmployeeContainer } from './styles/Employee.styles';

export interface EmployeeAdHocListProps {
  employeesToRound: Employee[];
  isLoading: boolean;
  searchTerm: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
}

const EmployeeAdHocList: FC<EmployeeAdHocListProps> = ({
  employeesToRound,
  isLoading,
  searchTerm,
  setSearchTerm
}) => {
  return (
    <EmployeeContainer id="Adhoc-Employee-Container">
      <div className="d-flex flex-column w-100">
        <SearchHeader searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        {isLoading ? (
          <Loading centered={false} />
        ) : (
          <AdhocEmployeesTable
            adhocEmployees={employeesToRound}
            searchTerm={searchTerm}
          />
        )}
      </div>
    </EmployeeContainer>
  );
};

const mapReduxStateToProps = (state: RootState) => {
  return {
    employeesToRound: state.EmployeeReducer.employeesToRound,
    isLoading: state.EmployeeReducer.loadingEmployeesToRound
  };
};

export default connect(mapReduxStateToProps)(EmployeeAdHocList);
